import script from "./ViewAddTournament.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAddTournament.vue?vue&type=script&setup=true&lang=js"

import "./ViewAddTournament.vue?vue&type=style&index=0&id=0d9969e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9969e6"]])

export default __exports__